import {Injectable, signal} from '@angular/core';

const STORAGE_KEY = 'gg-theme';

@Injectable({providedIn: 'root'})
export class ThemeService {
    private readonly _isDark = signal(false);
    readonly isDark = this._isDark.asReadonly();

    constructor() {
        const stored = localStorage.getItem(STORAGE_KEY);
        const prefersDark = stored ? stored === 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches;
        this._apply(prefersDark);
    }

    toggle(): void {
        this._apply(!this._isDark());
    }

    private _apply(dark: boolean): void {
        this._isDark.set(dark);
        document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
        localStorage.setItem(STORAGE_KEY, dark ? 'dark' : 'light');
    }
}
